import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randUuid, randBoolean } from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import type { MockServer, MirageServer } from './server.js'
import type { RawPostcodeLookupResponse } from '@/models/address.js'

export type PostcodeResultData = SchemaAttributes<'PostcodeResult'>

export const model = Model as ModelDefinition<PostcodeResultData>

const MOCK_RAW_ADDRESSES: RawPostcodeLookupResponse = {
  result: [1, 2, 3].map((n) => ({
    line_1: `${n} High Street`,
    line_2: '',
    line_3: '',
    post_town: 'Sample Town',
    dependant_locality: '',
    county: '',
  })),
}

export const factory = Factory.extend<PostcodeResultData>({
  id() {
    return randUuid()
  },
  is_result_available() {
    return randBoolean()
  },
  data() {
    return undefined
  },
  raw_data() {
    return this.is_result_available ? MOCK_RAW_ADDRESSES : undefined
  },
  error() {
    return undefined
  },
})

export function routes(server: MockServer) {
  server.get(
    '/postcodes/results/:task_id',
    function (this: MirageServer, schema, request) {
      const taskId = request.params.task_id

      return {
        data: {
          id: taskId,
          type: 'PostcodeResult',
          attributes: {
            is_result_available: true,
            data: null,
            raw_data: MOCK_RAW_ADDRESSES,
            error: undefined,
          },
        },
      }
    },
  )
}
